import { http } from '../../config/axios'

export default function getCacheProposta(id:String): Promise<String> {
  return http
    .get('api/propostacredito/' + id)
    .then((res) => {
      return res.data as String
    })
    .catch((error) => {
      console.error('Erro getCacheProposta', error)
      throw Error(error.response.data)
    })
}
